import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { RedoSingleSelectDropdownInput } from "@redotech/arbiter/select-dropdown/redo-single-select-dropdown-input";
import { DynamicRangeExpirationUnits } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { dynamicRangeExpirationUnitsOptions } from "../constants";

export function DynamicRangeExpirationField({
  value,
  setValue,
  units,
  setUnits,
}: {
  value: number | undefined;
  setValue: (value: number | undefined) => void;
  units: DynamicRangeExpirationUnits | undefined;
  setUnits: (value: DynamicRangeExpirationUnits) => void;
}) {
  return (
    <Flex align="center" gap="md">
      <RedoTextInput
        inputTypeHint="number"
        label="Expiration value"
        min={1}
        placeholder="1"
        setValue={(value) => {
          setValue(value ? Number(value) : undefined);
        }}
        value={value?.toString() ?? ""}
      />
      <RedoSingleSelectDropdownInput<DynamicRangeExpirationUnits>
        label="Expiration units"
        options={dynamicRangeExpirationUnitsOptions}
        optionSelected={({ item }) => {
          setUnits(item.value);
        }}
        selectedItem={dynamicRangeExpirationUnitsOptions.find(
          (o) => o.value === units,
        )}
        size="xs"
      />
    </Flex>
  );
}
